module.exports = __webpack_public_path__ + "img/stock2.e6c78c5e.png";